import { ArrowLeftOutlined } from '@/shared/ui/icons'
import UiFlex from '@/shared/ui/ui-flex'
import UiTypography from '@/shared/ui/ui-typography'
import { Button } from 'antd'
import clsx from 'clsx'
import type React from 'react'
import TitleCustom from './Title'

const { Text } = UiTypography

interface PageTitleProps {
  title: React.ReactNode
  subtitle?: React.ReactNode
  actions?: React.ReactNode
  className?: string
  onBack?: () => void
}

const PageTitle = ({ title, subtitle, actions, className, onBack }: PageTitleProps) => {
  return (
    <UiFlex
      align="center"
      justify="space-between"
      gap={24}
      className={clsx(className)}
      style={{ marginBottom: 8 }}
    >
      <UiFlex align="center" gap={16} style={{ minWidth: 0 }}>
        {onBack && (
          <Button
            type="text"
            icon={<ArrowLeftOutlined style={{ fontSize: 20 }} />}
            onClick={onBack}
            style={{
              display: 'flex',
              height: 40,
              width: 40,
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
            }}
          />
        )}
        <div style={{ minWidth: 0 }}>
          <TitleCustom desciption={typeof title === 'string' ? title : undefined}>
            {typeof title === 'string' ? null : title}
          </TitleCustom>

          {subtitle && (
            <Text type="secondary" style={{ marginTop: 4, display: 'block' }}>
              {subtitle}
            </Text>
          )}
        </div>
      </UiFlex>

      {actions && (
        <UiFlex flex="0 0 auto" align="center" gap={12}>
          {actions}
        </UiFlex>
      )}
    </UiFlex>
  )
}

export default PageTitle
